import styled from 'styled-components';

import 'antd/lib/switch/style/index.css';

// import 'antd/lib/date-picker/style/index.css';

import '~/styles/ant/datepicker.css';

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: column;

  color: #282828;
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    padding-bottom: 5px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 20px 10px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  span.alertGreen {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.17;
    letter-spacing: 0.01px;
    text-align: left;
    color: #74a50a;
    margin-top: -25px;
    display: block;
  }
`;

export const Container = styled.div`
  width: 100%;
  margin: 40px auto;
`;

export const Content = styled.div`
  /*
    styles antd
  */

  .BoxMonthPicker {
    .ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month {
      color: #fff;
      background: #74a50a;
    }
    .ant-calendar-month-panel-selected-cell
      .ant-calendar-month-panel-month:hover {
      color: #fff;
      background: #74a50a;
    }

    .ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month {
      color: #fff;
      background: #74a50a;
    }
    .ant-calendar-month-panel-selected-cell
      .ant-calendar-month-panel-month:hover {
      color: #fff;
      background: #74a50a;
    }
  }

  .errorMonthPicker {
    border: 1px solid #cc0000;
    border-radius: 5px;
  }

  /*
    styles antd
  */

  width: 80%;
  margin: 0 auto;
  p {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    color: #282828;
  }
  h3 {
    margin-bottom: 60px;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: center;
    color: #282828;
    span {
      color: #74a50a;
      font-weight: bold;
    }
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  margin: 40px auto;

  div.left {
    /* border: 1px solid red; */
    width: 45%;
  }

  div.right {
    /* border: 1px solid orange; */
    width: 50%;
  }

  input {
    width: 100%;
    background: #ffffff;
    border: 0;
    border-radius: 4px;
    height: 35px;
    padding: 0 15px;
    color: #282828;
    margin: 0 0 0 0;
    box-shadow: inset 0px 1px 0px 0px #c7c7c794;
    border: solid 1px #c7c7c794;
    &::placeholder {
      color: #282828;
    }
  }
  hr {
    border: solid 1px #b4b4b4;
    opacity: 0.37;
    margin: 30px auto;
  }
`;

export const ButtonBox = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  button {
    padding: 0 20px;
  }
`;

export const BoxForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 500px;
  margin: 0 auto;

  label {
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
    margin-bottom: 5px;
    display: block;
  }
  button.edit {
    width: 77px;
    height: 35px;
    border-radius: 3.5px;
    border: none;
    background-color: #235f6e;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      margin-right: 5px;
    }
  }
`;

export const TitleSection = styled.h4`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: 0.01px;
  text-align: left;
  color: ${props => (props.active === false ? '#CCC' : '#74a50a')};
  margin-bottom: 20px;
  span {
    padding-left: 10px;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: flex-end;
`;
export const Col = styled.div`
  margin: 15px;
  p {
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
  }
  span.errorField {
    color: #cc0000;
    font-size: 10px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;

    letter-spacing: 0px;
    margin-bottom: 5px;
  }
`;

export const Label = styled.span`
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: 0.01px;
  text-align: left;
  color: #282828;
  margin-bottom: 8px;
  display: block;
`;

export const SwitchButton = styled.div`
  .ant-switch {
    min-width: 55px;
    height: 28px;
    line-height: 25px;
  }
  .ant-switch-checked {
    background-color: #74a50a;
  }

  .ant-switch-loading-icon,
  .ant-switch::after {
    width: 24px;
    height: 24px;
  }
  &::selection {
    color: #fff;
    background: #74a50a;
  }
`;
